import(/* webpackMode: "eager" */ "/vercel/path0/src/app/data-deletion/page.tsx");
